export const FILTER__FORM_FIELDS_GLOBAL = {
    event: "",
    dateFrom: "",
    dateTo: ""
}